import * as React from "react";
import styled from "styled-components";
import { PopperSurface, PopperSurfaceProps } from "../PopperSurface";

type CascadeMenuProps = PopperSurfaceProps & {
    height: number
}

const StyledCascadeMenu = styled(PopperSurface) <{ height: number }>`
    box-sizing: content-box;
    // Note: "height: auto" is useless it just stops the transition if we are getting a height for the first time
    height: ${props => `${props.height}px` || "auto"};
    transition: height ${props => props.theme.transitions.long} ease;
    overflow: hidden;
    >div {
        position: relative;
    }
`;

export const CascadeMenu: React.FC<CascadeMenuProps> = (props) => {
    return <StyledCascadeMenu {...props}>
        <div>{props.children}</div>
    </StyledCascadeMenu>
}